import { SupportedRegions } from '@rbi-ctg/frontend';
import { getCountry } from 'utils/environment';

export function loadRegion(): SupportedRegions {
  // Obtained from Sanity FE Configuration
  return getCountry().toUpperCase();
}
